<form [formGroup]="queryForm">
  <mat-form-field class="search-bar">
    <input matInput formControlName="searchTxt">
    <button matSuffix mat-raised-button class="btn-normal" (click)="search()"><span class="fa fa-search"></span> {{ 'APPLICATIONS.SEARCH' | translate }} </button>
  </mat-form-field>
  <app-facet-chips [facetFilters]="facetFilters" (allFiltersRemoved)="removeFacetFilters()" (filterRemoved)="removeFacetFilter($event)"></app-facet-chips>
</form>
